"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _upArrow = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/up-arrow-1"));

var _downArrow = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/down-arrow-1"));

require("./InformationBlock.less");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var InformationBlock = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(InformationBlock, _React$Component);

  var _super = _createSuper(InformationBlock);

  function InformationBlock(props) {
    var _this;

    (0, _classCallCheck2.default)(this, InformationBlock);
    _this = _super.call(this, props);
    _this.state = {
      visible: null
    };
    _this.handleCollapse = _this.handleCollapse.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(InformationBlock, [{
    key: "handleCollapse",
    value: function handleCollapse() {
      var _this$props = this.props,
          collapsible = _this$props.collapsible,
          closed = _this$props.closed;

      if (collapsible) {
        var visible = this.state.visible;
        var toggleVisible = visible == null ? closed : !visible;
        this.setState({
          visible: toggleVisible
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          icon = _this$props2.icon,
          title = _this$props2.title,
          action = _this$props2.action,
          theme = _this$props2.theme,
          collapsible = _this$props2.collapsible,
          closed = _this$props2.closed,
          className = _this$props2.className,
          isActionable = _this$props2.isActionable,
          children = _this$props2.children;
      var visible = this.state.visible;
      var showContent = visible == null ? !closed : visible;
      var computedRootDivClassNames = (0, _classnames.default)('information-block', className, {
        'actionable': isActionable,
        'collapsible': collapsible,
        'collapsed': collapsible && !showContent
      });
      var actionDiv = action;

      if (collapsible) {
        actionDiv = showContent ? /*#__PURE__*/_react.default.createElement(_upArrow.default, null) : /*#__PURE__*/_react.default.createElement(_downArrow.default, null);
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: computedRootDivClassNames
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "information-block-header clearfix",
        onClick: this.handleCollapse
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pull-left"
      }, icon && /*#__PURE__*/_react.default.createElement("span", {
        className: "information-block-icon"
      }, icon), /*#__PURE__*/_react.default.createElement("span", {
        className: "information-block-header-title"
      }, title)), (action || collapsible) && /*#__PURE__*/_react.default.createElement("div", {
        className: "pull-right information-block-header-action"
      }, actionDiv)), /*#__PURE__*/_react.default.createElement("div", {
        className: "information-block-content ".concat(theme)
      }, /*#__PURE__*/_react.default.createElement("div", null, children)));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        icon: _propTypes.default.any,
        title: _propTypes.default.string.isRequired,
        action: _propTypes.default.any,
        isActionable: _propTypes.default.bool,
        theme: _propTypes.default.oneOf(['light', 'dark']),
        collapsible: _propTypes.default.bool,
        closed: _propTypes.default.bool,
        className: _propTypes.default.string
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        theme: 'light',
        closed: false,
        isActionable: false,
        className: ''
      };
    }
  }]);
  return InformationBlock;
}(_react.default.Component);

exports.default = InformationBlock;